var poll_default = {
  "fontElementMap": "A-MMU",
  "container": "LM0lj",
  "fullscreen": "k-4bt",
  "background_overlay": "gxPvH",
  "with_image": "tBsmt",
  "options": "JhmPE",
  "webview": "Wdkne",
  "grid": "vx-xG",
  "option": "Bpsyr",
  "cta_button": "kzmG4",
  "add_option": "I2Vzz",
  "see_more": "wGt4b",
  "list": "B6sLu",
  "column": "R1lgR",
  "additional_note": "UmxFF",
  "spinner": "KfmX-",
  "spin": "v9ZTy",
  "shown": "-pjte",
  "error": "_50hYM"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
